import { Component, ReactNode } from 'react';

/**
 * A rail panel that crashes must not take the app down (it did, tonight, when a
 * malformed activity payload killed the whole UI). The boundary renders an honest
 * one-line failure instead — the panel names its own breakage, the rest survives.
 */
export class PanelBoundary extends Component<{ name: string; children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    console.error(`[panel:${this.props.name}] render failed:`, error);
  }

  render() {
    if (this.state.failed) {
      return <div className="panel panel-failed">{this.props.name} could not render — the rest of the panel survives. Details are in the console.</div>;
    }
    return this.props.children;
  }
}
